import React from "react";
import PowerBiEmbed from "../../components/powerBiEmbed";
import { ReportUrls } from "../../constants/reportUrls";
import { SFPageContainer } from "@sf-core";


const BenchmarkReport = () => (
  <SFPageContainer disableGutters>
    <PowerBiEmbed url={ReportUrls.BenchmarkDashboard} />
  </SFPageContainer>
);

export default BenchmarkReport;
